// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__f4Nwv","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__w20Ph"};